/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_EqualsInputs */

const cs_op_equals = /** @type {(inputs: Op_EqualsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rovná se`)
};

const en_op_equals = /** @type {(inputs: Op_EqualsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`equals`)
};

/**
* | output |
* | --- |
* | "equals" |
*
* @param {Op_EqualsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_equals = /** @type {((inputs?: Op_EqualsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_EqualsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_equals(inputs)
	return cs_op_equals(inputs)
});